import {
  useCheckIsSuperAdmin,
  usePermissionEditAsset,
  usePermissionEditSharedAsset,
} from 'hooks';

export const useCheckAllowEditProductOverlayAsset = () => {
  const isSuperAdmin = useCheckIsSuperAdmin();
  const hasPermissionEditSharedAsset = usePermissionEditSharedAsset();
  const hasPermissionEditAsset = usePermissionEditAsset();

  const checkAllowEditProductOverlayAsset = () => {
    if (isSuperAdmin) return true;

    if (hasPermissionEditSharedAsset) return true;

    if (hasPermissionEditAsset) return true;

    return false;
  };

  return checkAllowEditProductOverlayAsset();
};
